export default "__VITE_ASSET__d6ca26de__"